export const platformPath = `api/v2/platform`

const endpoints = {
  addressesPath: (): string => `${platformPath}/addresses`,
  addressPath: (id: string): string => `${platformPath}/addresses/${encodeURIComponent(id)}`,
  adjustmentsPath: (): string => `${platformPath}/adjustments`,
  adjustmentPath: (id: string) => `${platformPath}/adjustments/${encodeURIComponent(id)}`,
  classificationsPath: (): string => `${platformPath}/classifications`,
  classificationPath: (id: string) => `${platformPath}/classifications/${encodeURIComponent(id)}`,
  countriesPath: (): string => `${platformPath}/countries`,
  countryPath: (id: string) => `${platformPath}/countries/${encodeURIComponent(id)}`,
  pagesPath: (): string => `${platformPath}/cms_pages`,
  pagePath: (id: string) => `${platformPath}/cms_pages/${encodeURIComponent(id)}`,
  sectionsPath: (): string => `${platformPath}/cms_sections`,
  sectionPath: (id: string) => `${platformPath}/cms_sections/${encodeURIComponent(id)}`,
  digitalsPath: (): string => `${platformPath}/digitals`,
  digitalPath: (id: string) => `${platformPath}/digitals/${encodeURIComponent(id)}`,
  linksPath: (): string => `${platformPath}/digital_links`,
  linkPath: (id: string) => `${platformPath}/digital_links/${encodeURIComponent(id)}`,
  linkResetPath: (id: string) => `${platformPath}/digital_links/${encodeURIComponent(id)}/reset`,
  itemsPath: (): string => `${platformPath}/line_items`,
  itemPath: (id: string) => `${platformPath}/line_items/${encodeURIComponent(id)}`,
  menusPath: (): string => `${platformPath}/menus`,
  menuPath: (id: string) => `${platformPath}/menus/${encodeURIComponent(id)}`,
  menuItemsPath: (): string => `${platformPath}/menu_items`,
  menuItemPath: (id: string) => `${platformPath}/menu_items/${encodeURIComponent(id)}`,
  menuItemRepositionPath: (id: string) => `${platformPath}/menu_items/${id}/reposition`,
  optionTypesPath: (): string => `${platformPath}/option_types`,
  optionTypePath: (id: string) => `${platformPath}/option_types/${encodeURIComponent(id)}`,
  optionValuesPath: (): string => `${platformPath}/option_values`,
  optionValuePath: (id: string) => `${platformPath}/option_values/${encodeURIComponent(id)}`,
  ordersPath: (): string => `${platformPath}/orders`,
  orderPath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}`,
  orderAdvancePath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/advance`,
  orderNextPath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/next`,
  orderCompletePath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/complete`,
  orderEmptyPath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/empty`,
  orderApprovePath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/approve`,
  orderCancelPath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/cancel`,
  orderCreditPath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/use_store_credit`,
  orderCouponPath: (id: string) => `${platformPath}/orders/${encodeURIComponent(id)}/apply_coupon_code`,
  paymentsPath: (): string => `${platformPath}/payments`,
  paymentPath: (id: string) => `${platformPath}/payments/${encodeURIComponent(id)}`,
  paymentMethodsPath: (): string => `${platformPath}/payment_methods`,
  paymentMethodPath: (id: string) => `${platformPath}/payment_methods/${encodeURIComponent(id)}`,
  productsPath: (): string => `${platformPath}/products`,
  productPath: (id: string) => `${platformPath}/products/${encodeURIComponent(id)}`,
  promotionsPath: (): string => `${platformPath}/promotions`,
  promotionPath: (id: string) => `${platformPath}/promotions/${encodeURIComponent(id)}`,
  promotionActionsPath: (): string => `${platformPath}/promotion_actions`,
  promotionActionPath: (id: string) => `${platformPath}/promotion_actions/${encodeURIComponent(id)}`,
  promotionCategoriesPath: (): string => `${platformPath}/promotion_categories`,
  promotionCategoryPath: (id: string) => `${platformPath}/promotion_categories/${encodeURIComponent(id)}`,
  promotionRulesPath: (): string => `${platformPath}/promotion_rules`,
  promotionRulePath: (id: string) => `${platformPath}/promotion_rules/${encodeURIComponent(id)}`,
  rolesPath: (): string => `${platformPath}/roles`,
  rolePath: (id: string) => `${platformPath}/roles/${encodeURIComponent(id)}`,
  shipmentsPath: (): string => `${platformPath}/shipments`,
  shipmentPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}`,
  shipmentAddItemPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/add_item`,
  shipmentRemoveItemPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/remove_item`,
  shipmentReadyPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/ready`,
  shipmentShipPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/ship`,
  shipmentCancelPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/cancel`,
  shipmentResumePath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/resume`,
  shipmentPendPath: (id: string) => `${platformPath}/shipments/${encodeURIComponent(id)}/pend`,
  shippingCategoriesPath: (): string => `${platformPath}/shipping_categories`,
  shippingCategoryPath: (id: string) => `${platformPath}/shipping_categories/${encodeURIComponent(id)}`,
  shippingMethodsPath: (): string => `${platformPath}/shipping_methods`,
  shippingMethodPath: (id: string) => `${platformPath}/shipping_methods/${encodeURIComponent(id)}`,
  statesPath: (): string => `${platformPath}/states`,
  statePath: (id: string) => `${platformPath}/states/${encodeURIComponent(id)}`,
  stockItemsPath: (): string => `${platformPath}/stock_items`,
  stockItemPath: (id: string) => `${platformPath}/stock_items/${encodeURIComponent(id)}`,
  stockLocationsPath: (): string => `${platformPath}/stock_locations`,
  stockLocationPath: (id: string) => `${platformPath}/stock_locations/${encodeURIComponent(id)}`,
  storeCreditCategoriesPath: (): string => `${platformPath}/store_credit_categories`,
  storeCreditCategoryPath: (id: string) => `${platformPath}/store_credit_categories/${encodeURIComponent(id)}`,
  storeCreditTypesPath: (): string => `${platformPath}/store_credit_types`,
  storeCreditTypePath: (id: string) => `${platformPath}/store_credit_types/${encodeURIComponent(id)}`,
  storeCreditsPath: (): string => `${platformPath}/store_credits`,
  storeCreditPath: (id: string) => `${platformPath}/store_credits/${encodeURIComponent(id)}`,
  taxCategoriesPath: (): string => `${platformPath}/tax_categories`,
  taxCategoryPath: (id: string) => `${platformPath}/tax_categories/${encodeURIComponent(id)}`,
  taxRatesPath: (): string => `${platformPath}/tax_rates`,
  taxRatePath: (id: string) => `${platformPath}/tax_rates/${encodeURIComponent(id)}`,
  taxonsPath: (): string => `${platformPath}/taxons`,
  taxonPath: (id: string) => `${platformPath}/taxons/${encodeURIComponent(id)}`,
  taxonRepositionPath: (id: string) => `${platformPath}/taxons/${encodeURIComponent(id)}/resposition`,
  taxonomiesPath: (): string => `${platformPath}/taxonomies`,
  taxonomyPath: (id: string) => `${platformPath}/taxonomies/${encodeURIComponent(id)}`,
  usersPath: (): string => `${platformPath}/users`,
  userPath: (id: string) => `${platformPath}/users/${encodeURIComponent(id)}`,
  variantsPath: (): string => `${platformPath}/variants`,
  variantPath: (id: string) => `${platformPath}/variants/${encodeURIComponent(id)}`,
  webhookEventsPath: (): string => `${platformPath}/webhooks/events`,
  webhookSubscribersPath: (): string => `${platformPath}/webhooks/subscribers`,
  webhookSubscriberPath: (id: string) => `${platformPath}/webhooks/subscribers/${encodeURIComponent(id)}`,
  wishlistsPath: (): string => `${platformPath}/wishlists`,
  wishlistPath: (id: string) => `${platformPath}/wishlists/${encodeURIComponent(id)}`,
  wishedItemsPath: (): string => `${platformPath}/wished_items`,
  wishedItemPath: (id: string) => `${platformPath}/wished_items/${encodeURIComponent(id)}`,
  zonesPath: (): string => `${platformPath}/zones`,
  zonePath: (id: string) => `${platformPath}/zones/${encodeURIComponent(id)}`
}

export default endpoints
